<mat-form-field class="date-time-input-field" floatLabel="always">
  <input
    matInput
    [dpDayPicker]="config"
    [mode]="'daytime'"
    theme="dp-material"
    type="text"
    autocomplete="off"
    [errorStateMatcher]="errorLabel !== undefined && alwaysError"
    [disabled]="isDisabled"
    [(ngModel)]="value"
    (blur)="propagateTouch()"
    [attr.data-testid]="testId ? testId : null"
    (ngModelChange)="setValue($event)"
    placeholder="dd/mm/yyyy, --:--"
  />
  <svg-icon *ngIf="!isDisabled" matSuffix key="calendar"></svg-icon>
  <mat-label *ngIf="label">{{ label }}</mat-label>
  <mat-hint *ngIf="hintLabel">{{ hintLabel }}</mat-hint>
  <mat-error *ngIf="errorLabel !== undefined">{{ errorLabel }}</mat-error>
</mat-form-field>
